import { tc } from 'language/i18nkey';
import { langutil } from 'language/langutil';
import { SrchType, useZstdSrch } from 'mainpage/toparea/srchinput/useZstdSrch';
import { KV } from 'models/IfKV';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import svcs from 'services';
import styled from 'styled-components';
import { isPathStartsWith } from 'util/ssqutil';
import { BRKS } from 'util/variables';
import { DropDown } from './DropDown';
import { useHandleSrch } from './useHandleSrch';

type Props = {
  novbar?: boolean;
  mobile?: boolean;
  enableNavToBoard?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const allKvs: KV<SrchType, string>[] = [
  { key: SrchType.ALL, val: tc('i18n_srch_dd_all') },
  { key: SrchType.DLCENTER, val: tc('i18n_srch_dd_dlcenter') },
  { key: SrchType.KNOWLEDGE, val: tc('i18n_srch_dd_knowledge') },
  { key: SrchType.SAMPLE, val: tc('i18n_srch_dd_sample') },
  { key: SrchType.QNA, val: tc('i18n_srch_dd_qna') },
  { key: SrchType.NEWS_EVENT, val: tc('i18n_srch_dd_news_evnet') },
];

export const SrchDropDown = ({ novbar, mobile, enableNavToBoard, ...props }: Props) => {
  const { pathname } = useLocation();
  const { setSrchType, srchType, input: srchInput } = useZstdSrch();
  const { handleNavToBoard } = useHandleSrch();

  const { country } = langutil.splitLangCode(svcs.svcLang.lang());
  const kvs = country !== 'us' ? allKvs : allKvs.filter((kv) => kv.key !== SrchType.QNA);

  const [sel, setSel] = useState<KV<SrchType, string>>(
    kvs.find((kv) => kv.key === srchType) || { key: SrchType.ALL, val: tc('i18n_srch_dd_all') }
  );

  useEffect(() => {
    if (isPathStartsWith(pathname, '/dlcenter') || isPathStartsWith(pathname, '/product/document/')) {
      setSel(kvs.find((kv) => kv.key === SrchType.DLCENTER));
    } else if (isPathStartsWith(pathname, '/community/blog')) {
      setSel(kvs.find((kv) => kv.key === SrchType.KNOWLEDGE));
    } else if (isPathStartsWith(pathname, '/community/qna')) {
      setSel(kvs.find((kv) => kv.key === SrchType.QNA) || kvs.find((kv) => kv.key === SrchType.ALL));
    } else if (isPathStartsWith(pathname, '/community/board')) {
      setSel(kvs.find((kv) => kv.key === SrchType.NEWS_EVENT));
    } else if (isPathStartsWith(pathname, '/service/sample')) {
      setSel(kvs.find((kv) => kv.key === SrchType.SAMPLE));
    } else if (isPathStartsWith(pathname, '/main') || isPathStartsWith(pathname, '/search3')) {
      setSel(kvs.find((kv) => kv.key === SrchType.ALL));
    }
  }, [pathname]);

  // React.useEffect(() => {
  //   const sel = kvs.find((kv) => kv.key === srchType);
  //   if (sel) {
  //     setSel(sel);
  //   }
  //   //setSel(kvs.find((kv) => kv.key === srchType) || {key: 'all', val: tc('i18n_srch_dd_all')});
  // }, [srchType]);

  React.useEffect(() => {
    setSrchType(sel.key);
  }, [sel]);

  return (
    <Body {...props} data-id='header-srch-dropdown'>
      <DropDown
        label={sel?.val || ''}
        kvs={kvs}
        sels={[]}
        onChange={(kv) => {
          setSel(kv);
          if (enableNavToBoard && !srchInput?.trim()) handleNavToBoard(kv.key);
        }}
        width='14rem'
        listStyle={mobile ? { right: '0.4rem' } : { left: '0.4rem' }}
        mobile={mobile}
      />
      {!novbar && <VBar />}
    </Body>
  );
};

const VBar = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  border-right: 1px solid #d9d9d9;
`;
const Body = styled.div`
  position: relative;
  width: 14.5rem;
  align-self: stretch;
  display: flex;
  align-items: center;
  //min-width: 16.5rem;

  @media screen and (max-width: ${BRKS.mobileMax}) {
    width: auto;
    flex-shrink: 0;
    justify-content: flex-end;
  }
`;
